import React from "react";
import clsx from "clsx";
import { LuiFormLabel } from "@linzjs/lui";

class TextInput extends React.Component {
  render() {
    return (
      <>
        {this.props.label && (
          <LuiFormLabel
            label={this.props.label}
            for={this.props.name}
            tooltip={this.props.tooltip}
          />
        )}
        <div className={clsx(
                "lui-margin-top-xs lui-standard-form",
                this.props.error && "lui-input-error"
              )}
        >
          {
            this.props.error && (<i className="lui-form-status-icon material-icons-round">
              error
            </i>)
          }
          <input
            id={this.props.name}
            name={this.props.name}
            type={this.props.type || "text"}
            onChange={this.props.onChange}
            {...this.props.inputProps}
          />
          {
            this.props.error && (<p className="lui-error-msg">{this.props.errorMessage}</p>)
          }
        </div>
      </>
    )
  }
}

class RadioGroup extends React.Component {
  render() {
    return (
      <div
        className="lui-fieldsetBlock-form-group"
      >
        <fieldset>
          <legend>
            <p>
              {this.props.legend}
            </p>
          </legend>
          <div className="lui-input-group-wrapper">{this.props.children}</div>
        </fieldset>
      </div>
    );
  }
}

class RadioButton extends React.Component {
  render() {
    return (
      <div>
        <div className="lui-radio-container">
          <input
            disabled={this.props.disabled}
            name={this.props.name}
            checked={this.props.checked}
            value={this.props.value}
            id={this.props.value}
            type="radio"
            onChange={this.props.onChange}
            {...this.props.inputProps}
          />
          <label htmlFor={this.props.value}>{this.props.label}</label>
        </div>
      </div>
    );
  }
}

class MultiCheckbox extends React.Component {
  render() {
    return (
      <div className="">
        <div className="lui-input-group-wrapper ">
          <div className="lui-checkbox-container">
            <input
              {...this.props.inputProps}
              type="checkbox"
              name={this.props.name}
              id={this.props.value}
              value={this.props.value}
              checked={this.props.checked}
              disabled={this.props.disabled}
              onChange={this.props.onChange}
              style = {this.props.style}
              className="g-checkboxes__input"
            />
            {typeof this.props.label === "string" ? (
              <label htmlFor={this.props.value}>{this.props.label}</label>
            ) : (
              this.props.label
            )}
          </div>
        </div>
      </div>
    );
  }
}

export {MultiCheckbox, RadioGroup, RadioButton, TextInput};
